import { EmptyLayout } from "@/components/common/EmptyLayout";

export interface TableNoContentProps {
  title?: string;
  description?: string;
  className?: string;
}

export const TableNoContent = ({
  title = "Nenhum resultado encontrado",
  description,
  className,
}: TableNoContentProps) => {
  return <EmptyLayout title={title} description={description} className={className} />;
};
